import { Button, ButtonTheme } from '@cian/button-component';
import { OutsideClick, Popup, PopupArrow } from '@cian/components';
import * as React from 'react';

import { IGetOfferDataResponseSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IPageData } from '../../../store';
import { trackShareClick } from '../tracking';
import { IconFacebook, IconOk, IconSharing, IconTwitter, IconVk } from './icons';

import * as styles from './index.css';
import { getGeoLabel } from '../../../utils/meta/partials/getGeoLabel';

export interface ISharingButtonProps {
  offerData: IGetOfferDataResponseSchema;
  pageData: IPageData;
  title: string;
}

export interface ISharingState {
  isOpenPopup: boolean;
}

export class SharingButton extends React.Component<ISharingButtonProps, ISharingState> {
  private input: HTMLInputElement | null;

  public state = {
    isOpenPopup: false,
  };

  public render() {
    const { pageData } = this.props;

    return (
      <div className={styles['container']}>
        <Button
          theme={ButtonTheme.Ghost}
          className={styles['sharing_button']}
          onClick={() => {
            this.openPopup();

            trackShareClick();
          }}
          title="Поделиться"
        >
          <IconSharing />
        </Button>
        {this.state.isOpenPopup && (
          <OutsideClick rootElement={<div />} onOutsideClick={this.closePopup}>
            <Popup arrow={PopupArrow.RIGHT} containerStyle={styles['popup']}>
              <div className={styles['social_row']}>
                <div className={styles['vk']} onClick={() => this.handleSocialLink('vk')}>
                  <IconVk />
                </div>
                <div className={styles['ok']} onClick={() => this.handleSocialLink('ok')}>
                  <IconOk />
                </div>
                <div className={styles['facebook']} onClick={() => this.handleSocialLink('facebook')}>
                  <IconFacebook />
                </div>
                <div className={styles['twitter']} onClick={() => this.handleSocialLink('twitter')}>
                  <IconTwitter />
                </div>
              </div>
              <input
                ref={input => (this.input = input)}
                /* tslint:disable-next-line:max-line-length */
                value={`https://${pageData.subdomain}.cian.ru/${pageData.dealType}/${pageData.offerType}/${pageData.offerId}`}
                className={styles['input_link']}
                disabled
              />
              {// tslint:disable-next-line:strict-type-predicates
              typeof document !== 'undefined' && (
                <div className={styles['copy_link']} onClick={this.handleCopyLink}>
                  Скопировать ссылку
                </div>
              )}
            </Popup>
          </OutsideClick>
        )}
      </div>
    );
  }

  private openPopup = () => {
    this.setState({
      isOpenPopup: true,
    });
  };

  private closePopup = () => {
    this.setState({
      isOpenPopup: false,
    });
  };

  private handleCopyLink = () => {
    if (this.input) {
      this.input.disabled = false;
      this.input.select();

      try {
        document.execCommand('copy');
        this.input.disabled = true;
      } catch (e) {}
    }
  };

  private handleSocialLink = (socialType: string) => {
    const { offerData, pageData, title } = this.props;
    let url: string | undefined;

    const link = `https://${pageData.subdomain}.cian.ru/${pageData.dealType}/${pageData.offerType}/${pageData.offerId}`;
    const utmMarked = `?utm_medium=social_repost&utm_campaign=card_social_repost&utm_source=${socialType}`;

    const description = getGeoLabel(offerData.offer);
    const image =
      offerData.offer && offerData.offer.photos && offerData.offer.photos.length > 0
        ? offerData.offer.photos[0].fullUrl
        : '';

    switch (socialType) {
      case 'vk':
        url = [
          `https://vk.com/share.php?url=${encodeURIComponent(link + utmMarked)}`,
          `title=${encodeURIComponent(title)}`,
          `description=${encodeURIComponent(description)}`,
          `image=${encodeURIComponent(image)}`,
          `noparse=true`,
        ].join('&');
        break;

      case 'ok':
        url = [
          `https://connect.ok.ru/offer?url=${encodeURIComponent(link + utmMarked)}`,
          `title=${encodeURIComponent(title)}`,
        ].join('&');
        break;

      case 'twitter':
        url = [
          `https://twitter.com/intent/tweet?url=${encodeURIComponent(link + utmMarked)}`,
          `text=${encodeURIComponent(title)}`,
        ].join('&');
        break;

      case 'facebook':
        url = [
          `https://www.facebook.com/v2.5/dialog/share?app_id=681114281993063`,
          `description=${encodeURIComponent(description)}`,
          `display=popup`,
          `href=${encodeURIComponent(link + utmMarked)}`,
          `locale=en_US`,
          `picture=${encodeURIComponent(image)}`,
          `sdk=joey`,
          `title=${encodeURIComponent(title)}`,
          `version=v2.5`,
        ].join('&');
        break;

      default:
        return;
    }

    const popupWidth = 800;
    const popupHeight = 600;
    const popupTopPosition = (window.outerHeight - popupHeight) / 2;
    const popupLeftPosition = (window.outerWidth - popupWidth) / 2;

    // tslint:disable-next-line:max-line-length
    const popupParams = `width=${popupWidth}, height=${popupHeight}, scrollbars=0, top=${popupTopPosition}, left=${popupLeftPosition}`;

    window.open(url, '', popupParams);
  };
}
